import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, authed, errMsg } from "@/lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const DownloadCatalogButton = ({ catId }) => {
  const [job, setJob] = useState(null);

  const start = async () => {
    try {
      let { data } = await api.post(`/categories/${catId}/catalog-pdf`);
      setJob(data);
      const deadline = Date.now() + 10 * 60 * 1000;
      while (data.status === "running") {
        if (Date.now() > deadline) throw new Error("The PDF is taking too long, please try again");
        await wait(2000);
        try { data = (await api.get(`/pdf-jobs/${data.id}`)).data; setJob(data); } catch { /* retry */ }
      }
      if (data.status === "failed") throw new Error(data.error || "PDF build failed");
      Object.assign(document.createElement("a"), { href: authed(`/pdf-jobs/${data.id}/download`) }).click();
      toast.success(`Downloading ${data.filename}`, { description: `${(data.size / 1048576).toFixed(1)} MB` });
    } catch (e) { toast.error(e.message || errMsg(e)); }
    setJob(null);
  };

  const label = !job ? "Download PDF"
    : job.total ? `${job.step} ${job.current}/${job.total}` : job.step || "Preparing…";
  return (
    <Button variant="outline" onClick={start} disabled={!!job} data-testid="download-catalog-button">
      {job ? <Loader2 size={14} className="mr-2 animate-spin" /> : <Download size={14} className="mr-2" />}
      <span data-testid="download-catalog-status">{label}</span>
    </Button>
  );
};
